class ThemeMode {
  mode = $state<'light' | 'dark'>()

  init() {
    const isDark =
      localStorage.theme === 'dark' ||
      window.matchMedia('(prefers-color-scheme: dark)').matches

    this.mode = isDark ? 'dark' : 'light'
  }

  toggle = () => {
    this.mode = this.mode === 'dark' ? 'light' : 'dark'
    localStorage.theme = this.mode
  }

  use() {
    $effect(() => {
      document.documentElement.classList.toggle('dark', this.mode === 'dark')
    })
  }
}
export const themeMode = new ThemeMode()
